import { css } from '@emotion/react';
import { Skeleton } from '@spotnana/blocks/src/Skeleton';
import { Surface } from '@spotnana/blocks/src/Surface';

const checkout_section_loader = css`
  padding: 16px 54px;
`;

const CheckoutSectionLoader = (): JSX.Element => (
  <Surface css={checkout_section_loader} borderRadius="outer" variant="base" data-testid="checkout-section-loader">
    <Skeleton variant="rectangular" width="full" height="30px" />
  </Surface>
);

export default CheckoutSectionLoader;
